export default "__VITE_ASSET__BdeVaaAc__"